import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _AddToBankOptions;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { View } from '@instructure/ui-view';
import { CondensedButton } from '@instructure/ui-buttons';
import { jsx } from '@instructure/emotion';
import { ADD_TO_BANK_MODAL, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/es/format-message';
export var AddToBankOptions = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_AddToBankOptions = /*#__PURE__*/function (_Component) {
  function AddToBankOptions() {
    var _this;
    _classCallCheck(this, AddToBankOptions);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AddToBankOptions, [].concat(args));
    _defineProperty(_this, "openAddToBankModal", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var displayPosition, msg;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            displayPosition = _this.props.displayPosition;
            if (!_this.props.isValid) {
              _context.next = 5;
              break;
            }
            _this.props.openModal([ADD_TO_BANK_MODAL, _this.props.entryType, _this.props.guid].join(':'), {
              modalTrigger: _this.addToBankLink
            });
            _context.next = 10;
            break;
          case 5:
            msg = t('{entryType} {displayPosition, number} cannot be saved due to invalid input data.', {
              entryType: _this.props.entryType,
              displayPosition: displayPosition
            });
            _this.props.screenreaderNotification(msg);
            _context.next = 9;
            return _this.props.showError(_this.props.guid);
          case 9:
            _this.props.focusFirstErrorField();
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "storeAddToBankLinkRef", function (c) {
      _this.addToBankLink = c;
    });
    return _this;
  }
  _inherits(AddToBankOptions, _Component);
  return _createClass(AddToBankOptions, [{
    key: "render",
    value: function render() {
      return jsx("div", null, jsx(View, {
        as: "div",
        css: this.props.styles.addToBank
      }, jsx(CondensedButton, {
        color: "primary",
        ref: this.storeAddToBankLinkRef,
        onClick: this.openAddToBankModal,
        "data-automation": "sdk-add-to-bank-link",
        margin: "small"
      }, t('Add to Bank'))));
    }
  }]);
}(Component), _defineProperty(_AddToBankOptions, "displayName", 'AddToBankOptions'), _defineProperty(_AddToBankOptions, "componentId", "Quizzes".concat(_AddToBankOptions.displayName)), _defineProperty(_AddToBankOptions, "propTypes", {
  displayPosition: PropTypes.number.isRequired,
  entryType: PropTypes.string.isRequired,
  focusFirstErrorField: PropTypes.func,
  guid: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  styles: PropTypes.object
}), _defineProperty(_AddToBankOptions, "defaultProps", {
  focusFirstErrorField: function focusFirstErrorField() {}
}), _AddToBankOptions)) || _class);
export default AddToBankOptions;